import {Component, inject, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Observable, of, ReplaySubject, switchMap} from 'rxjs';
import {Graphic, GraphicService} from '../graphic.service';
import {catchError} from 'rxjs/operators';

@Component({
  selector: 'app-catalog-graphic',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './catalog-graphic.component.html',
  styleUrls: ['./catalog-graphic.component.scss']
})
export class CatalogGraphicComponent {

  private readonly graphicService = inject(GraphicService);
  readonly imageId$ = new ReplaySubject<number>(1);
  readonly graphic$: Observable<Graphic> = this.imageId$.pipe(
    switchMap((imageId) => imageId ? this.fetchGraphic(imageId) : of({} as Graphic))
  );

  @Input() set imageId(imageId: number) {
    this.imageId$.next(imageId || 0);
  }

  @Input() imageSize = 50;

  @Input() imageClasses = '';

  fetchGraphic(imageId: number): Observable<Graphic> {
    return this.graphicService.fetchGraphic(imageId).pipe(
      catchError((error) => {
          console.error(error);
          return of({} as Graphic);
        }
      ));
  }

}
